/** Client timeout for POST /tradiefileshare (zip + upload + email can be slow). */
export const TRADIEFILESHARE_EXPORT_TIMEOUT_MS = 600000

/** Client timeout for POST /tradiefileshare/size (storage size() per file). */
export const TRADIEFILESHARE_SIZE_TIMEOUT_MS = 180000

/**
 * One entry per tradie id for the share payload (backend expects unique tradies).
 * @param {Array<{ id?: number }>} entries
 * @returns {Array}
 */
export function uniqueTradieShareEntries(entries) {
  const byId = new Map()
  for (const entry of entries || []) {
    if (!entry || entry.id == null) continue
    const id = entry.id
    if (!byId.has(id)) byId.set(id, entry)
  }
  return [...byId.values()]
}
